import { atom } from 'jotai';

import { Toast } from '../models/toast';

const toastAtom = atom<Toast[]>([]);

export default toastAtom;
